import { Component, Inject } from '@angular/core';

import { Subject } from 'rxjs';

import { MessageCollationneService } from '../services/message-collationne.service';
import { MessageCollationneDTO } from '../entities/message-collationne-dto.entity';
import { MessagesCollationnesFilters } from '../entities/messages-collationnes-filters.entity';

import { UserService } from '../../humain/user/services/user.service';
import { UserTLR } from '../../humain/user/entities/user-tlr.entity';

@Component({
	selector: 'messages-collationnes',
	templateUrl: 'messages-collationnes.html',
})
export class MessagesCollationnesComponent {
	currentFilters!: MessagesCollationnesFilters;
	isLoading: boolean = true;
	messages: MessageCollationneDTO[] = [];
	user!: UserTLR;
		
	openCreationDialogSubject = new Subject<MessageCollationneDTO[]>();
	openViewDialogSubject = new Subject<MessageCollationneDTO>();
	
	constructor( //
		@Inject(MessageCollationneService) private messageCollationneService: MessageCollationneService,
		@Inject(UserService) userService: UserService,
	) {
		let user$ = userService.getCurrentUserTLR();
		user$.subscribe(
			(user) => this.user = user
		)
	}

	/////////////////////////////////////
	// Gestion des actions utilisateur //
	/////////////////////////////////////
	
	onNewMessageRequest() {
		this.openCreationDialogSubject.next(this.messages);
	}

	onMessageCollationneCreated() {
		this.reloadData();
	}
	
	onFilterRequest(filters: MessagesCollationnesFilters) {
		this.currentFilters = filters;
		this.reloadData();
	}
	
	onRowClicked(message: MessageCollationneDTO) {
		this.openViewDialogSubject.next(message);
	}
	
	private reloadData() {
		this.isLoading = true;
		this.messageCollationneService.getMessagesByFilters(this.currentFilters).subscribe(
			(results: MessageCollationneDTO[]) => {
				this.messages = results;
				this.isLoading = false;
			}
		);
	}
}